import * as constants from "../constants/builder-errors";

export const hideErrors = () => ({ type: constants.HIDE_ERRORS });
export const showErrors = () => ({ type: constants.SHOW_ERRORS });
